{
  "familyId": "GET-BREUK-KEER",
  "questions": [
    {
      "id": "GET-BREUK-KEER-001",
      "familyId": "GET-BREUK-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Hoeveel is $\\frac{1}{2} \\times \\frac{1}{3}$?",
      "options": [
        "$\\frac{1}{6}$",
        "$\\frac{2}{5}$",
        "$\\frac{1}{5}$",
        "$\\frac{2}{6}$"
      ],
      "correctAnswer": 0,
      "conceptId": "multiply_fractions_basic",
      "variantIndex": 1,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              { "numerator": 1, "denominator": 2 },
              { "numerator": 1, "denominator": 3 }
            ],
            "operator": "×",
            "label": "$\\frac{1}{2} \\times \\frac{1}{3}$",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 6,
            "label": "1 × 1 = 1 (teller) · 2 × 3 = 6 (noemer) → $\\frac{1}{6}$",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij breuken vermenigvuldigen: teller × teller en noemer × noemer. Stap 1: teller = 1 × 1 = 1. Stap 2: noemer = 2 × 3 = 6. Antwoord: $\\frac{1}{6}$.",
        "distractorExplanations": {
          "0": "Goed! 1 × 1 = 1 (teller) en 2 × 3 = 6 (noemer), dus $\\frac{1}{6}$.",
          "1": "$\\frac{2}{5}$ is de optellen-fout: teller 1+1=2 en noemer 2+3=5. Bij vermenigvuldigen tel je NIET op — je vermenigvuldigt teller × teller en noemer × noemer.",
          "2": "$\\frac{1}{5}$ klopt niet: de teller is correct (1×1=1), maar de noemer is opgeteld (2+3=5) in plaats van vermenigvuldigd (2×3=6).",
          "3": "$\\frac{2}{6}$ klopt niet: de noemer is correct (2×3=6), maar de teller is opgeteld (1+1=2) in plaats van vermenigvuldigd (1×1=1)."
        }
      }
    },
    {
      "id": "GET-BREUK-KEER-002",
      "familyId": "GET-BREUK-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Bereken: $\\frac{2}{3} \\times \\frac{3}{4}$",
      "options": [
        "$\\frac{1}{2}$",
        "$\\frac{6}{12}$",
        "$\\frac{5}{7}$",
        "$\\frac{2}{4}$"
      ],
      "correctAnswer": 0,
      "conceptId": "multiply_fractions_simplify",
      "variantIndex": 2,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              { "numerator": 2, "denominator": 3 },
              { "numerator": 3, "denominator": 4 }
            ],
            "operator": "×",
            "label": "$\\frac{2}{3} \\times \\frac{3}{4}$",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "label": "2×3=6 en 3×4=12 → $\\frac{6}{12}$ → vereenvoudigd ÷6 → $\\frac{1}{2}$",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stap 1: teller × teller = 2 × 3 = 6. Stap 2: noemer × noemer = 3 × 4 = 12. Uitkomst: $\\frac{6}{12}$. Stap 3: vereenvoudigen — GGD van 6 en 12 is 6. Dus 6 ÷ 6 = 1 en 12 ÷ 6 = 2. Antwoord: $\\frac{1}{2}$.",
        "distractorExplanations": {
          "0": "Goed! 2×3=6 en 3×4=12 geeft $\\frac{6}{12}$, vereenvoudigd ÷6 = $\\frac{1}{2}$.",
          "1": "$\\frac{6}{12}$ is de tussenstap vóór vereenvoudigen. Je bent er bijna — deel teller én noemer nog door 6: $\\frac{6}{12}$ = $\\frac{1}{2}$.",
          "2": "$\\frac{5}{7}$ is de optellen-fout: 2+3=5 (teller) en 3+4=7 (noemer). Bij vermenigvuldigen tel je NIET op — je vermenigvuldigt teller × teller en noemer × noemer.",
          "3": "$\\frac{2}{4}$ klopt niet: je hebt alleen de eerste teller (2) en de eerste noemer (4) gebruikt en de tweede breuk genegeerd. Vermenigvuldig beide breuken volledig."
        }
      }
    },
    {
      "id": "GET-BREUK-KEER-003",
      "familyId": "GET-BREUK-KEER",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Emma heeft $\\frac{1}{4}$ van een taart. Ze geeft $\\frac{1}{2}$ daarvan aan haar zus. Hoeveel taart heeft haar zus?",
      "options": [
        "$\\frac{1}{8}$",
        "$\\frac{3}{4}$",
        "$\\frac{1}{2}$",
        "$\\frac{2}{8}$"
      ],
      "correctAnswer": 0,
      "conceptId": "multiply_fractions_context",
      "variantIndex": 3,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              { "numerator": 1, "denominator": 2 },
              { "numerator": 1, "denominator": 4 }
            ],
            "operator": "×",
            "label": "$\\frac{1}{2}$ van $\\frac{1}{4}$ = $\\frac{1}{2} \\times \\frac{1}{4}$",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 8,
            "label": "1×1=1 en 2×4=8 → $\\frac{1}{8}$ van de taart",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "\"De helft van een kwart\" betekent $\\frac{1}{2} \\times \\frac{1}{4}$. Stap 1: teller = 1 × 1 = 1. Stap 2: noemer = 2 × 4 = 8. Antwoord: $\\frac{1}{8}$ van de taart.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{2} \\times \\frac{1}{4}$: teller 1×1=1 en noemer 2×4=8 → $\\frac{1}{8}$.",
          "1": "$\\frac{3}{4}$ is de optellen-fout: $\\frac{1}{4} + \\frac{1}{2}$ = $\\frac{1}{4} + \\frac{2}{4}$ = $\\frac{3}{4}$. Maar de vraag zegt \"de helft DAARVAN\" — dat is vermenigvuldigen, niet optellen.",
          "2": "$\\frac{1}{2}$ klopt niet: je hebt alleen de tweede breuk ($\\frac{1}{2}$) als antwoord gegeven en de $\\frac{1}{4}$ genegeerd. \"De helft van een kwart\" is kleiner dan $\\frac{1}{2}$.",
          "3": "$\\frac{2}{8}$ klopt niet: de noemer is correct (2×4=8), maar de teller is opgeteld (1+1=2) in plaats van vermenigvuldigd (1×1=1)."
        }
      }
    }
  ]
}
